import {EditModel} from "./EditModel";
import {Scanner} from "../../entities/Scanner";
import {ScannerService} from "../../services/ScannerService";
import {PrintJobService} from "../../services/PrintJobService";
import {NotificationService} from "../../services/NotificationService";
import {Asset} from "../../entities/Asset";
import {Template} from "../../entities/Template";
import {PrintJob} from "../../entities/PrintJob";

export class EditScannerModel extends EditModel<Scanner> {
    entityId:number;
    static $inject = ['$q','ScannerService','PrintJobService','NotificationService'];
    constructor($q:ng.IQService, public service:ScannerService,
                public printjobService:PrintJobService, public notifyService:NotificationService){
        super($q, service, Scanner);
    }
    saveData(): ng.IPromise<boolean> {
        var promis = this.entity.inactive ? this.service.deactivate(this.entity.deviceID) : this.service.activate(this.entity.deviceID);
        return promis.then((data) => {
            return this.service.update(this.entity).then((data) => {
                return this.$q.when<boolean>(true);
            });
        });
    }
    verifyData(): ng.IPromise<boolean>{
        if (this.entity.deviceID == null || this.entity.deviceID.length == 0) {
            this.notifyService.notifyError("Device ID is required.");
            return this.$q.when<boolean>(false);
        }
        return this.service.getByDeviceID(this.entity.deviceID).then((data) => {
            if (data == null) {
                this.notifyService.notifyError("Scanner must first be registered by itself.");
                return this.$q.when<boolean>(false);
            }
            else {
                return this.$q.when<boolean>(true);
            }
        });      
    }
   
}
